import InformationCard from './InformationCard';

export default InformationCard;
